import {  TextField } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

export const OrangeTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '#ff9800',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#ff9800',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'red',
      },
      '&:hover fieldset': {
        borderColor: 'yellow',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#ff9800',
      },
    },
  },
})(TextField);